import React, { useState } from "react";
import { v4 } from "uuid";
import Image from "next/image";

type Alumni = {
  youtube: string;
  name: string;
  img: string;
  description: string;
  des: string;
  compLogo: string;
  alliance: string;
  alt: string;
  location: string;
  linkdin: string;
};

const UspAlumniUSMobile: React.FC = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  const cardData: Alumni[] = [
    {
      name: "Vijay Reddy",
      img: "/accounting/al1.png",
      alt: "vijay reddy, accounting alumni - miles education",
      description:
        "With Miles by my side, I turned my dream of a US accounting career into a thriving reality. Their expertise made all the difference in my success.",
      des: "With Miles by my side, I turned my dream of a US accounting career into a thriving reality. Their expertise made all the difference in my success.",
      compLogo: "/accounting/fl.png",
      alliance: "BDO Alliance",
      location: "Redlands, CA",
      linkdin: "https://www.linkedin.com/in/vijaynrkonduru/",
      youtube: "https://youtube.com/shorts/He2cwbYxp44?feature=share",
    },
    {
      name: "Hyder Syed",
      alt: "hyder sayed, accounting alumni - miles education",
      img: "/accounting/al2.jpeg",
      description:
        "Choosing the Miles US Pathway was a smart move. Thanks to Miles Placement Team for guiding me through it. I've embraced, conquered, and now I'm ready to fly! ",
      des: "Choosing the Miles US Pathway was a smart move. Thanks to Miles Placement Team for guiding me through it. I've embraced, conquered, and now I'm ready to fly! ",
      compLogo: "/newImages/MilesEducationWebsite-2024/MBE_Logo.png",
      alliance: "BDO Alliance",
      location: "Chandler, AZ",
      linkdin: "http://linkedin.com/in/hyder-syed",
      youtube: "https://youtube.com/shorts/myS4Ic_FfA0?feature=share",
    },
    {
      name: "Manisha Kulkarni ",
      alt: "manisha kulkarni, accounting alumni - miles education",
      img: "/accounting/al3.webp",
      description:
        "Miles helped me master my field and turn my American Dream into reality by securing my placement in the US. Grateful for their expertise and support.",
      des: "Miles helped me master my field and turn my American Dream into reality by securing my placement in the US. Grateful for their expertise and support.",

      compLogo: "/newImages/MilesEducationWebsite-2024/rsm.png",
      alliance: "BDO Alliance",
      location: "Philadelphia, PA",
      linkdin: "https://www.linkedin.com/in/manisha-kulkarni-060634187/",
      youtube: "https://youtube.com/shorts/vcNGtncehYY?feature=share",
    },
    {
      name: "Anand Sharma",
      alt: "anand sharma, accounting alumni - miles education",
      img: "/accounting/al4.webp",
      description:
        "The Miles US Pathway program was a game-changer for my career growth. Massive thanks to the Miles Placement team for their invaluable support and guidance throughout!",
      des: "The Miles US Pathway program was a game-changer for my career growth. Massive thanks to the Miles Placement team for their invaluable support and guidance throughout!",

      compLogo: "/accounting/ksdt.png",
      location: "Miami, FL ",
      alliance: "BDO Alliance",
      linkdin: "https://in.linkedin.com/in/anand-sharma-080b0314a",
      youtube: "https://youtube.com/shorts/NbKbS-2Nv1o?feature=share",
    },

    {
      name: "Mahesh S ",
      img: "/accounting/al5.JPG",
      alt: "mahesh s, accounting alumni - miles education",
      description:
        "Never thought a US accounting career was possible for me until Miles made it happen. Forever grateful for their support",
      des: "Never thought a US accounting career was possible for me until Miles made it happen. Forever grateful for their support",

      compLogo: "/newImages/MilesEducationWebsite-2024/rsm.png",
      location: "New York City, NY",
      alliance: "RSM Alliance",
      linkdin: "https://www.linkedin.com/in/mahesh-s-5a50b1127",
      youtube: "https://youtube.com/shorts/7an8N6hHclc?feature=share",
    },

    {
      name: "Lavika Sharma",
      img: "/newImages/MilesEducationWebsite-2024/alumni/Lavika.png",
      alt: "lavika sharma, accounting alumni - miles education",
      description:
        "Thanks to Miles, my US work dream is now a reality! Ready for the next career chapter with a bag full of wins waiting. ",
      des: "Thanks to Miles, my US work dream is now a reality! Ready for the next career chapter with a bag full of wins waiting.  ",

      compLogo: "/newImages/MilesEducationWebsite-2024/alumni/logo1.png",
      location: " Minneapolis, MN",
      alliance: "Allinial Alliance",
      linkdin: "https://www.linkedin.com/in/lavika-sharma-6b9703165/",
      youtube: "https://youtube.com/shorts/_Fz6_qI0IK8?feature=share",
    },
    {
      name: "Disha Rungta",
      img: "/accounting/al7.webp",
      alt: "disha rungta, accounting alumni - miles education",
      description:
        "Thanks to Miles, I'm diving into a thrilling new chapter in the US. This transition is huge for me, and I'm excited for what's next!",
      des: "Thanks to Miles, I'm diving into a thrilling new chapter in the US. This transition is huge for me, and I'm excited for what's next!",

      compLogo: "/newImages/MilesEducationWebsite-2024/rsm.png",
      location: "New York City, NY",
      alliance: "  Alliance",
      linkdin: "https://www.linkedin.com/in/disha-rungta?",
      youtube: "https://youtube.com/shorts/UTdmgdGxGug?feature=share",
    },
    {
      name: "Vinay Kumar",
      img: "/accounting/al8.jpg",
      alt: "vinay kumar, accounting alumni - miles education",
      description:
        "With Miles it was a smooth journey of not just all round support and improvement but also elevating my confidence in myself in achieving my dream.",
      des: "With Miles it was a smooth journey of not just all round support and improvement but also elevating my confidence in myself in achieving my dream.",

      compLogo: "/accounting/lg4.png",
      location: "Chapel Hill, NC",
      alliance: "RSM Alliance",
      linkdin: "http://linkedin.com/in/402581189",
      youtube: "https://www.youtube.com/shorts/z-cwdKrwqN4",
    },
    {
      name: "Vamshi Teja",
      img: "/accounting/al9.jpeg",
      alt: "vamshi teja, accounting alumni - miles education",
      description:
        "Moving to the US has been a transformative journey. Thanks to Miles, I’ve had an incredible year and am thrilled to begin my new job!",
      des: "Moving to the US has been a transformative journey. Thanks to Miles, I’ve had an incredible year and am thrilled to begin my new job!",

      compLogo: "/accounting/fl.png",
      location: "Redlands, CA",
      alliance: "RSM Alliance",
      linkdin: "https://www.linkedin.com/in/vamshi-teja-vangala-604081141/",
      youtube: "https://youtube.com/shorts/e9UwNPzHG2Q?feature=share",
    },
  ];

  return (
    <>
      <div className="w-full md:pt-[60px] pt-[30px] md:pb-[80px] pb-[30px] bg-[#0C1F33] relative">
        <Image
          src="/images/accounting/usp/Payment-mount.png"
          alt="Special Offer"
          className="mx-auto absolute md:bottom-0 bottom-0 left-0 w-full z-[0]"
          width={350}
          height={307}
          priority
        />
        <div
          className="lg:container mx-auto  h-full 2xl:px-0 xl:px-10 lg:px-6 px_5 relative lg:hidden block"
          id="alumni2"
        >
          <div
            className="lg:pb-20 lg:pt-0 md:py-6 md:pb-10 lg:px-0 md:px-5 px-3 pt-5 pb-10"
            id="how"
          >
            <Image
              src="/cpa/bg_mil.png"
              alt="cpa/bg_mil"
              className="mx-auto absolute bottom-0 left-0"
              width={503}
              height={433}
              loading="lazy"
            />

            <div className="text-center pb-5">
              <h2 className="relative text-[24px] lg:text-[40px] md:text-[38px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white text-center px-[4px] tracking-[-0.24px]">
                <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                  Miles alumni in the US
                </span>
              </h2>
            </div>
            <div className="justify-between flex gap-4 scrollbar-hide overflow-y-auto ">
              <div
                className="flex w-[280px] min-w-[280px] flex-col items-start gap-2 shadow-[0px_0px_2px_0px_rgba(4,84,175,0.25)] relative flex flex-col h-[204px] w-full cursor-pointer max-w-[400px] shadow-md rounded-lg overflow-hidden border-[1px] border-white"
                onClick={() => {
                  openPopup("WCHY6bvBTxM");
                }}
              >
                <Image
                  src="/images/accounting/usp/aakash.png"
                  alt="Miles US Pathway Roadmap"
                  className="w-full h-full object-cover"
                  width={580}
                  height={352}
                  priority
                />
              </div>

              {cardData.map((data) => (
                <div
                  className="rounded-[8px] bg-white shadow-[0px_0px_2px_0px_rgba(4,84,175,0.25)] border border-[#f5f3f3] flex w-[253px] min-w-[253px] p-3 flex-col items-start gap-2 relative flex flex-col h-[204px] w-full max-w-[300px] bg-white shadow-md rounded-lg p-4 py-[12px] px-[12px]"
                  key={v4()}
                >
                  <a href={data.linkdin} target="_blank" className="flex-grow">
                    <div className="flex items-center gap-[9px]">
                      <div>
                        <img
                          loading="lazy"
                          src={data.img}
                          alt={data.alt}
                          className="w-10 h-10 rounded-[40px] object-cover object-top"
                        />
                      </div>
                      <div className="flex items-center gap-[9px]">
                        <p className="text-[#0C1F33] text-center text-[16px] not-italic font-semibold leading-[normal]">
                          {data.name}
                        </p>
                        <img
                          src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/lin.webp"
                          alt="linkedin icon"
                          className="w-5 h-5 object-contain"
                          loading="lazy"
                        />
                      </div>
                    </div>

                    <div className="py-2">
                      <p className="text-[#535353] text-[12px] not-italic font-medium  line-clamp-3 tracking-[-0.48px]">
                        {data.des}
                      </p>
                    </div>

                    <div className="flex items-center justify-between py-2">
                      <img
                        src={data.compLogo}
                        alt="Company Logo"
                        className="w-[50px]  object-contain"
                        loading="lazy"
                      />
                      <p className="text-[14px] font-normal text-black tracking-[-0.14px]">
                        {data.location}
                      </p>
                    </div>
                  </a>

                  <a
                    href={data.youtube || "#"}
                    target="_blank"
                    className="inline-block text-[12px] font-medium text-[#535353] bg-[#F5F5F5] rounded-[18px] px-2 py-1 w-[145px] h-[28px] mt-[-9px] tracking-[-0.56px] story_shadow"
                  >
                    <img
                      src="/yt.png"
                      alt="YouTube Icon"
                      className="inline-block mr-2 w-[20px] h-[20px]"
                      loading="lazy"
                    />
                    Watch my story
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspAlumniUSMobile;
